export const customerActions = {}